export const WhatArkIsSection: React.FC = () => {
  const connectorChips = [
    "Autodesk Construction Cloud",
    "BIM 360",
    "BIM",
    "SharePoint",
    "Teams",
    "Box",
    "OneDrive",
    "Dropbox",
    "Zendesk",
    "ERP / CSV Exports"
  ];

  return (
    <section
      id="what-ark-is"
      className="what-ark-is-section section-spacing bg-gradient-to-b from-gray-50 to-white"
    >
      <div className="container mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl font-bold text-slate-900 mb-6 leading-tight">
            A System of Intelligence, built on an Intelligence Layer
          </h2>
          <p className="text-lg text-slate-700 leading-relaxed">
            ARK isn't another system to manage. It's the intelligence layer across your existing ecosystem, connecting project sources into trusted answers and action.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left column - Bullets and definition */}
          <div className="space-y-8">
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-base text-slate-700">Sits above existing tools (no workflow overhaul)</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-base text-slate-700">Unifies context across documents and systems</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-base text-slate-700">Turns knowledge into evidence-backed outputs</span>
              </li>
            </ul>

            {/* Definition box */}
            <div className="rounded-2xl border-2 border-violet-200 bg-violet-50 p-6">
              <p className="text-lg font-semibold text-violet-900">
                ARK turns what you already have into a trusted system of intelligence.
              </p>
            </div>
          </div>

          {/* Right column - Connected ecosystem */}
          <div className="space-y-6">
            <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
              <h3 className="text-xl font-bold text-slate-900 mb-4">Connected Ecosystem</h3>
              <p className="text-slate-700 mb-6 leading-relaxed">
                Drawings, specs, RFIs, field logs, project systems, and exports, unified into a single intelligence layer.
              </p>

              {/* Connector chips */}
              <div className="flex flex-wrap gap-2">
                {connectorChips.map((chip) => (
                  <span
                    key={chip}
                    className="inline-flex items-center rounded-full bg-slate-100 text-slate-700 px-3 py-1.5 text-sm font-medium"
                  >
                    {chip}
                  </span>
                ))}
              </div>
            </div>

            {/* Outcome statement */}
            <div className="text-center">
              <p className="text-lg font-semibold text-slate-900">
                One search surface. One evidence-backed answer. One path to action.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
